import { render, staticRenderFns } from "./DropdownOption.vue?vue&type=template&id=18fd97e0&scoped=true&"
import script from "./DropdownOption.vue?vue&type=script&lang=js&"
export * from "./DropdownOption.vue?vue&type=script&lang=js&"
import style0 from "./DropdownOption.vue?vue&type=style&index=0&id=18fd97e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fd97e0",
  null
  
)

export default component.exports